import React from 'react';
import Icon, { ICON_NAME } from "../../../../../../../components/Icon";
import { datetime } from "../../../../../../../util/library/datetime";
import { SHORT_TIME_FORMAT } from '../../../../../../../util/varibles/constants';
import { useRoundMap } from '../../../EditOperationContext/RoundMapContext';
import styles from "../style.module.scss";
import { IPropsChild } from "./index";

const Traveling: React.FC<IPropsChild> = (props) => {
    const { start_time = 0, finish_time = 0, place } = props;
    const { format = SHORT_TIME_FORMAT } = useRoundMap()
    return <div className={styles.traveling}>
        <div className='mr-2'>
            {[datetime(start_time).format(format), `-- Traveling to ${place} --`, datetime(finish_time).format(format)].join(' ')}
        </div>
        <Icon icon={ICON_NAME.VESSEL_3} style={{ width: '50px', height: '30px' }} />
    </div>
};

export default Traveling;
